export default __webpack_public_path__ + "static/media/greenGarments.e66d1820.png";